import { Button, OptionList, Popover } from '@shopify/polaris';
import { useCallback, useEffect, useState } from 'react';

const FilterSelect = ({ slug, name, options, onFilterChange, defaultValue, defaultOptions = true }) => {
  const [popoverActive, setPopoverActive] = useState(false);
  const [selected, setSelected] = useState(
    defaultValue ? decodeURIComponent(defaultValue).split(':').map(encodeURI) : [],
  );
  const togglePopoverActive = useCallback(() => setPopoverActive((popoverActive) => !popoverActive), []);

  useEffect(() => {
    setSelected(defaultValue ? decodeURIComponent(defaultValue).split(':').map(encodeURI) : []);
  }, [defaultValue]);

  const handleSelectionChange = useCallback(
    (selected) => {
      setSelected(selected);
      onFilterChange({
        slug,
        value: selected.map(decodeURIComponent).join(':'),
      });
    },
    [setSelected, onFilterChange, slug],
  );

  const activator = (
    <Button onClick={togglePopoverActive} disclosure primary={selected.length}>
      {name}
    </Button>
  );

  return (
    <Popover active={popoverActive} activator={activator} onClose={togglePopoverActive}>
      <OptionList
        title={name}
        onChange={handleSelectionChange}
        options={
          defaultOptions
            ? options.map((o) => ({
                label: o,
                value: encodeURI(o),
              })) ?? []
            : options
        }
        selected={selected}
        allowMultiple
      />
    </Popover>
  );
};

export default FilterSelect;
